// eslint-disable-next-line no-restricted-globals
const isNumericKey = (key) => !isNaN(Number(key));

export default function convertObjectToArray(data) {
  let validatedData = data;

  if (validatedData && !Array.isArray(validatedData)) {
    validatedData = Object.keys(data)
      .filter(isNumericKey)
      .map((key) => data[key]);
  }

  return validatedData;
}
